<template>
  <div :key="renderKey">
    <Dashboard
      v-if="queryDashboardScreen(screen)"
      :transactionName="transactionName"
      :screen="screen"
      :allQueryData="allQueryData"
      :loadedTransaction="loadedTransaction"
      :loading="loading"
      :method="method"
      :menu="menu"
      :queryPage="queryPage"
      :queryPages="queryPages"
      :querySort="querySort"
      :queryChecks="queryChecks"
      :generalExApplicationEx="generalExApplicationEx"
      :customLanguage="customLanguage"
      :queryUploadLog="queryUploadLog"
      :queryRichData="queryRichData"
      :page="page"
      :checks="checks"
      :allChecked="allChecked"
      :changed="changed"
      :fileUpload="fileUpload"
      :showQueryFieldsEx="showQueryFieldsEx"
    />
    <v-simple-table
      v-if="!queryDashboardScreen(screen)"
      fixed-header
      dense
      class="query-table"
    >
      <template v-slot:default>
        <thead v-if="!custom || !custom.hideHeader">
          <tr>
            <th
              v-if="bulkCheck(screen) || showBulkChecks()"
              class="text-center grey lighten-1 table-header"
            >
              <v-checkbox
                v-model="allChecked"
                @change="allCheckedChange"
                dense
              ></v-checkbox>
            </th>
            <th
              v-if="smallQuery(screen) || (custom && custom.small)"
              class="text-center grey lighten-1 table-header"
            ></th>
            <th
              v-else
              v-for="(queryColumn, colIdx) in showQueryFieldsEx()"
              :key="colIdx"
              class="pt-1 text-center grey lighten-1 table-header"
              @click="sortColumn(queryColumn.oriIndex)"
            >
              <span class="">
                {{
                  translatedConfig(
                    generalExApplicationEx,
                    customLanguage,
                    queryColumn.queryField,
                    "caption"
                  )
                }}
              </span>
              <v-icon light small>
                {{ sortIcon(queryColumn.oriIndex) }}
              </v-icon>
            </th>
            <th
              v-if="showDynamicActions(null)"
              class="text-center grey lighten-1 table-header"
            >
              <v-icon> mdi-blur </v-icon>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            :key="recIdx"
            v-for="(queryRecord, recIdx) in allQueryData"
            :style="cellStyle(queryRecord)"
          >
            <td
              v-if="bulkCheck(screen) || showBulkChecks()"
              :class="'text-center ' + tableCellClass()"
            >
              <!-- Bulk check -->
              <div class="text-center">
                <v-checkbox
                  v-model="checks[recIdx]"
                  @change="checkChange"
                  dense
                >
                </v-checkbox>
              </div>
            </td>
            <td
              v-if="smallQuery(screen) || (custom && custom.small)"
              :class="tableCellClass()"
            >
              <v-container>
                <v-row>
                  <v-col>
                    <div
                      v-for="(queryColumn, colIdx) in showQueryFieldsEx()"
                      :key="colIdx"
                      :class="
                        queryFieldContainerClass(
                          queryColumn.queryField.fieldName,
                          queryRecord
                        )
                      "
                    >
                      <QueryField
                        :id="cellId(queryColumn.queryField.fieldName, recIdx)"
                        :ref="
                          cellId(queryColumn.queryField.fieldName, recIdx) +
                          'Ref'
                        "
                        :dictionary="
                          findDictionary(
                            screen,
                            queryColumn.queryField.dictionaryName
                          )
                        "
                        :value="smartFieldValue(queryRecord, queryColumn.queryField.fieldName)"
                        :items="
                          findCatalogExList(
                            screen,
                            queryColumn.queryField.dictionaryName,
                            null
                          )
                        "
                        :coordinates="{
                          recordId: recIdx,
                          fieldId: queryColumn.oriIndex,
                          fieldName: queryColumn.queryField.fieldName,
                        }"
                        :permission="menu.permission"
                        :method="method"
                        :access="queryColumn.queryField.access"
                        :preview="queryColumn.queryField.preview"
                        :label="
                          translatedConfig(
                            generalExApplicationEx,
                            customLanguage,
                            queryColumn.queryField,
                            'caption'
                          )
                        "
                        :generalExApplicationEx="generalExApplicationEx"
                        :customLanguage="customLanguage"
                        :loading="getField(queryColumn.oriIndex).loading"
                        :queryField="queryColumn.queryField"
                        :queryRecord="queryRecord"
                        :screen="screen"
                        :environment="environment"
                        :queryExtended="
                          getExtended(
                            queryRecord.__oriIndex,
                            queryColumn.queryField.fieldName
                          )
                        "
                        @handle-change="handleChange"
                      />
                      <Actions
                        v-if="
                          showDynamicActions(
                            queryColumn.queryField.fieldName,
                            queryRecord
                          )
                        "
                        :show="true"
                        :types="['dynamic']"
                        :method="null"
                        :transactionMethod="null"
                        :actions="screen.actions"
                        :generalExApplicationEx="generalExApplicationEx"
                        :customLanguage="customLanguage"
                        :coordinates="{ recordId: recIdx }"
                        :small="true"
                        :data="queryRecord"
                        :position="queryColumn.queryField.fieldName"
                        :dictionaryngList="dictionaryingList"
                        :catalogingList="catalogingList"
                        @call-action="callAction"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </td>
            <td
              v-else
              v-for="(queryColumn, colIdx) in showQueryFieldsEx()"
              :key="colIdx"
              :class="tableCellClass()"
            >
              <div
                :class="
                  queryFieldContainerClass(
                    queryColumn.queryField.fieldName,
                    queryRecord
                  ) +
                  fieldAlign({
                    dictionary: findDictionary(
                      screen,
                      queryColumn.queryField.dictionaryName
                    ),
                    screen,
                  })
                "
              >
                <QueryField
                  :id="cellId(queryColumn.queryField.fieldName, recIdx)"
                  :ref="
                    cellId(queryColumn.queryField.fieldName, recIdx) + 'Ref'
                  "
                  :dictionary="
                    findDictionary(
                      screen,
                      queryColumn.queryField.dictionaryName
                    )
                  "
                  :value="smartFieldValue(queryRecord, queryColumn.queryField.fieldName)"
                  :items="
                    findCatalogExList(
                      screen,
                      queryColumn.queryField.dictionaryName,
                      null
                    )
                  "
                  :coordinates="{
                    recordId: recIdx,
                    fieldId: queryColumn.oriIndex,
                    fieldName: queryColumn.queryField.fieldName,
                  }"
                  :permission="menu.permission"
                  :method="method"
                  :access="queryColumn.queryField.access"
                  :preview="queryColumn.queryField.preview"
                  :generalExApplicationEx="generalExApplicationEx"
                  :customLanguage="customLanguage"
                  :loading="getField(queryColumn.oriIndex).loading"
                  :queryField="queryColumn.queryField"
                  :queryRecord="queryRecord"
                  :screen="screen"
                  :environment="environment"
                  :queryExtended="
                    getExtended(
                      queryRecord.__oriIndex,
                      queryColumn.queryField.fieldName
                    )
                  "
                  @handle-change="handleChange"
                />
                <Actions
                  v-if="
                    showDynamicActions(
                      queryColumn.queryField.fieldName,
                      queryRecord
                    )
                  "
                  class="query-field-actions"
                  :show="true"
                  :types="['dynamic']"
                  :method="null"
                  :transactionMethod="null"
                  :actions="screen.actions"
                  :generalExApplicationEx="generalExApplicationEx"
                  :customLanguage="customLanguage"
                  :coordinates="{ recordId: recIdx }"
                  :small="true"
                  :data="queryRecord"
                  :position="queryColumn.queryField.fieldName"
                  :dictionaryngList="dictionaryingList"
                  :catalogingList="catalogingList"
                  @call-action="callAction"
                />
              </div>
            </td>
            <td v-if="showDynamicActions(null)" :class="'text-left ' + tableCellClass()">
              <Actions
                :show="true"
                :types="['dynamic']"
                :method="null"
                :transactionMethod="null"
                :actions="screen.actions"
                :generalExApplicationEx="generalExApplicationEx"
                :customLanguage="customLanguage"
                :coordinates="{ recordId: recIdx }"
                :small="true"
                :data="queryRecord"
                @call-action="callAction"
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <br />

    <Actions
      :show="true"
      :types="['bulkCheck', 'bulkContent', 'bulkDynamic']"
      :method="null"
      :transactionMethod="null"
      :actions="screen.actions"
      :generalExApplicationEx="generalExApplicationEx"
      :customLanguage="customLanguage"
      :coordinates="{}"
      :elevation="20"
      :changed="changed"
      :queryChanged="queryChanged"
      :large="true"
      :data="allFormData"
      @call-action="callAction"
    />

    <br /><br />

    <div
      v-if="
        pageableQuery(screen) &&
        queryLoaded &&
        (!custom || !custom.hidePagination)
      "
      class="text-center"
    >
      <v-container>
        <v-row
          v-if="!smallQuery(screen) && !(custom && custom.small)"
          dense
          justify="center"
        >
          <v-col cols="5" />
          <v-col cols="1">
            <v-autocomplete
              :label="translatedText('pageLimitText')"
              v-model="limit"
              :items="paginationOptions()"
              item-text="id"
              item-value="id"
              dense
              outlined
              disable-lookup
              :loading="querying"
              :disabled="querying"
              @change="changeQueryLimit"
            />
          </v-col>
          <v-col cols="1">
            <v-text-field
              :label="translatedText('totalRecordsText')"
              :value="queryCount"
              dense
              outlined
              readonly
              disabled
            />
          </v-col>
          <v-col cols="5" />
        </v-row>
        <v-row v-if="queryPages > 1" dense justify="center">
          <v-col cols="2" />
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="page"
                :length="queryPages"
                :color="secondaryColor(generalExApplicationEx)"
                @next="updatePage"
                @previous="updatePage"
                @input="updatePage"
              ></v-pagination>
            </v-container>
          </v-col>
          <v-col cols="2" />
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import QueryField from "./fields/QueryField";
import Dashboard from "./Dashboard";
import Actions from "./Actions";
export default {
  name: "Query",
  props: [
    "transactionName",
    "screen",
    "allQueryData",
    "loadedTransaction",
    "loading",
    "method",
    "menu",

    "actions",

    "allActions",
    "dynamicActions",
    "queryActions",

    "queryLoaded",
    "queryCount",
    "queryPage",
    "queryPages",
    "querySort",
    "queryChecks",
    "queryLimit",
    "querying",
    "renderKey",
    "generalExApplicationEx",
    "customLanguage",
    "queryUploadLog",
    "queryRichData",
    "queryExtendedData",

    "environment",

    "queryChanged",
    "custom",

    "allFormData",

    "dictionaryingList",
    "catalogingList",
  ],
  display: "Query",
  components: {
    QueryField,
    //ButtonField,
    Dashboard,
    Actions,
  },
  data() {
    return {
      page: this.queryPage,
      limit: this.queryLimit,
      checks: this.queryChecks,
      allChecked: false,
      changed: false,
      fileUpload: null,
    };
  },
  methods: {
    showQueryFieldsEx() {
      if (this.loadedTransaction) {
        let outQueryFieldsEx = [];
        this.screen.queryFieldsEx.forEach((queryFieldEx, index) => {
          if (queryFieldEx.queryField.access != "hidden") {
            queryFieldEx.oriIndex = index;
            outQueryFieldsEx.push(queryFieldEx);
          }
        });
        return outQueryFieldsEx;
      } else {
        return [];
      }
    },

    callAction(params) {
      this.$emit("call-action", params);
    },
    sortIcon(column) {
      if (this.querySort && this.querySort[column]) {
        let icon =
          this.querySort[column].sort == "asc"
            ? "mdi-arrow-up-drop-circle"
            : this.querySort[column].sort == "desc"
            ? "mdi-arrow-down-drop-circle"
            : "";
        return icon;
      }
    },
    sortColumn(column) {
      this.$emit("sort-column", column);
    },

    updatePage() {
      this.$emit("update-page-query", this.page);
    },
    allCheckedChange() {
      for (let i = 0; i < this.checks.length; i++) {
        this.checks[i] = this.allChecked;
      }
      this.changed = true;
      this.$emit("query-check-change", this.checks);
    },
    checkChange() {
      this.changed = true;
      this.$emit("query-check-change", this.checks);
    },
    initChecks(checks) {
      this.checks = checks;
      this.allChecked = false;
      this.changed = false;
    },
    doFileDownload() {
      this.$emit("query-file-download");
    },
    doFileUpload() {
      this.$refs.fileUploadRef.$refs.input.click();
    },
    fileUploadChange() {
      this.getBase64(this.fileUpload).then((binary) => {
        const data = {
          binary,
          name: this.fileUpload.name,
        };
        this.$emit("query-file-upload", data);
        this.fileUpload = null;
      });
    },
    showQueryUploadLog() {
      this.$emit("show-query-upload-log");
    },
    getField(getId) {
      return this.queryRichData[this.getFieldId(getId)];
    },
    showDynamicActions(position, data) {
      return (
        this.selectActions({
          actions: this.screen.actions,
          types: ["dynamic"],
          position,
          data,
        }).length > 0
      );
    },
    showBulkChecks() {
      return (
        this.selectActions({
          actions: this.screen.actions,
          types: ["bulkCheck", "bulkDynamic"],
        }).length > 0
      );
    },
    cellStyle(record) {
      const spreadColor = this.querySpreadColor(this.screen, record);
      return spreadColor
        ? "background-color: " + this.hexaColor(spreadColor)
        : null;
    },

    handleChange(data) {
      this.$emit("handle-change-query", data);
    },

    onResize() {},

    queryFieldContainerClass(position, data) {
      if (this.showDynamicActions(position, data)) {
        return " query-field-wrapper ";
      } else {
        return " ";
      }
    },

    changeQueryLimit() {
      this.$emit("update-page-limit", this.limit);
    },

    setFieldValue(args) {
      try {
        const fieldRef = args.id + "Ref";
        this.$refs[fieldRef][0].setValue(args);
      } catch (error) {
        console.log(error)
      }
    },

    paginationOptions() {
      let list = [
        { id: 10 },
        { id: 20 },
        { id: 30 },
        { id: 50 },
        { id: 100 },
        { id: 200 },
      ];
      if (list.find((item) => item.id == this.queryLimit) == null) {
        list.push({ id: this.queryLimit });
        list.sort((a, b) => {
          return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
        });
      }
      return list;
    },

    tableScroll() {},

    getExtended(indexRecord, fieldName) {
      return this.queryExtendedData[indexRecord] &&
        this.queryExtendedData[indexRecord].data[fieldName]
        ? this.queryExtendedData[indexRecord].data[fieldName]
        : {};
    },

    tableCellClass() {
      return this.smallQuery(this.screen) || (this.custom && this.custom.small)
        ? "table-cell"
        : "table-cell-lg";
    }
  },
  updated() {},
  mounted() {},
};
</script>

<style scoped>
.query-table {
  table-layout: fixed;
}
.table-header {
  border-left: solid 1px #000;
  border-right: solid 1px #000;
  vertical-align: top;
}
.table-cell {
  border-left: solid 1px #ddd;
  border-right: solid 1px #ddd;
  border-bottom: solid 1px #ddd;
  vertical-align: top;
}

.table-cell-lg {
  border-left: solid 1px #ddd;
  border-right: solid 1px #ddd;
  border-bottom: solid 1px #ddd;
  vertical-align: top;
}
.table-cell div {
  padding-top: 0;
  padding-bottom: 0;
}
.table-cell-lg div {
  padding-top: 3px;
}
.query-field-wrapper {
  display: flex;
}
.query-field-actions {
  margin-left: 5px;
}
</style>
